<template>
    <v-card>
      <v-card-actions>
        <v-spacer></v-spacer>
      
      </v-card-actions>
      <v-card-title class="ma-4">
        <span class="headline" v-if ="contactId">Contato</span>
        <span class="headline" v-if ="!contactId">Novo contato</span>
     
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="3" sm="12">
            <v-select
              class="mt-5"
              v-model="contact.typeId"
              :items="typeOptions"
              label="Tipo de contato"
              item-text="text"
              item-value="value"
              dense
            >
            </v-select>
          </v-col>

          <v-col cols="12" md="4" sm="12">
            <v-text-field label="Nome" v-model="contact.name">
            </v-text-field>
          </v-col>

          <v-col cols="12" md="4" sm="12">
            <v-text-field label="Email" v-model="contact.email">
            </v-text-field>
          </v-col>
<!-- v-mask= "(contact.phone.length<=13)?'(##)####-####':'(##)#####-####' " -->
           <v-col cols="12" md="4">
              <v-text-field
                label="Fone"
                hide-details="auto"
                v-model="contact.phone"
              v-if = "loaded"
                  v-mask= "(contact.phone.length<=13)?'(##)####-####':'(##)#####-####'  "
              ></v-text-field>
            </v-col>

          <v-col cols="12" md="4" v-if="contact.typeId == 1">
            <v-text-field
              label="CNPJ"
              hide-details="auto"
              v-model="contact.cnpj"
              v-mask="'##.###.###/####-##'"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4" v-if="contact.typeId == 1">
            <v-text-field
              label="I.E."
              hide-details="auto"
              v-model="contact.ie"
              v-mask="'###.###.###.###'"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4" v-if="contact.typeId == 2">
            <v-text-field
              label="CPF"
              hide-details="auto"
              v-model="contact.cpf"
              v-mask="'###.###.###-##'"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <autocomplete-city
              @changed="changedCity"
              :preSearch="contact.cityName"
            ></autocomplete-city>
          </v-col>

          <v-col cols="12" md="9">
            <v-text-field
              label="Endereço"
              hide-details="auto"
              v-model="contact.streetAddress"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              label="CEP"
              hide-details="auto"
               v-mask="'##.###-###'"
               @blur="updatedZipCode"
              v-model="contact.zipCode"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="1">
            <v-text-field
              label="Número"
              hide-details="auto"
              v-model="contact.streetAddressNumber"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              label="Complemento"
              hide-details="auto"
              v-model="contact.streetAddressLine2"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              label="Bairro"
              hide-details="auto"
              v-model="contact.neighborhood"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text> 

        <v-row>
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="saveContact">Salvar</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
</template>

<script>
import Contact from "../../../../libraries/classes/Contact";
import hebelApi from '../../../../libraries/hebel/hebelApi';
import AutocompleteCity from "../../component/AutocompleteCity.vue";

export default {
  components: { AutocompleteCity },
  name: "contact",
  props: ["showDialog", "section", "deviceTypes","contactId"],
  data() {
    return {
      loaded :false,
      contact: {},
      user:{},
      typeOptions: [
        { value: 1, text: "Empresa" },
        { value: 2, text: "Pessoa" },
      ],
    };
  },

  watch: {
    searchCity(val) {
      val && val !== this.select && this.querySelections(val);
    },
  },
  computed: {},
  created() {
    this.user = this.$session.get('user');
    // this.preSearch = ""
  },
 async mounted() {
      if(this.contactId){
            this.contact = await hebelApi.contacts.getFromId(this.contactId);
           // alert(JSON.stringify  (this.contact))
      }else{
           this.contact = new Contact();
           this.contact.ownerId = this.user.uid;
       }
       this.loaded =true;
  
  },

  methods: {
     async updatedZipCode() {
     // alert("test>:" + this.site.zipCode);

      var info = await this.$globalFunctions.searchZipCode(this.contact.zipCode);
      //var info = await this.$globalFunctions.searchZipCode("13.026-340");
      
      this.search = info.cityName;
      this.contact.cityName = info.cityName;
      
     //alert(JSON.stringify(info));
      this.contact.streetAddress = info.streetAddress;
      this.contact.neighborhood = info.neighborhood;
      //this.site.

    },


    async saveContact(){

        await hebelApi.contacts.upsert(this.contact);
        this.$router.push("/contacts")
    },
    changedCity(cityName) {
      this.contact.cityName = cityName;
    },

    close() {
      // alert("close")
      this.$emit("close");
    },
  },
};
</script>


<style scoped>
</style>